import { useFilterInitialization } from './hooks/useFilterInitialization';
import { useFilters } from '../FilterContext';

export const TableSortFilter = () => {
	const { initialValues } = useFilters();

	// Initialize tableSort using the generic useFilterInitialization hook
	// Since tableSort is special (we handle it like chips), we pass custom logic
	useFilterInitialization('tableSort', [], {
		getDefaultValue: () => {
			// Check if there's an initial value from URL/localStorage (handled by FilterContext)
			const storedId = initialValues.tableSort;
			
			if (storedId && storedId.includes('_')) {
				const [sortField, sortOrder] = storedId.split('_');
				return {
					id: storedId,
					name: `${sortField} (${sortOrder === 'asc' ? 'Ascending' : 'Descending'})`
				};
			}
			
			// Default to no sort
			return { id: '', name: 'Default Sort' };
		},
		getParams: (sortOption) => {
			// Parse the sortField and sortOrder from the id
			if (!sortOption.id) {
				return { sortField: '', sortOrder: 'asc' };
			}
			const [sortField, sortOrder] = sortOption.id.split('_');
			return { sortField, sortOrder };
		},
		waitForData: false, // Don't wait for dataSource since sort is completely dynamic
	});

	// This is a pseudo-filter that doesn't render anything
	return null;
};